import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  Typography 
} from '@mui/material';
import { useError } from '../../context/ErrorContext';

export const ErrorModal: React.FC = () => {
  const { error, clearError } = useError();

  const handleClose = () => {
    clearError();

    if ((error as any)?.isInitializationError) {
      window.location.reload();
    }
  };

  const getErrorMessage = (error: Error | null) => {
    if (!error) return '';

    // Safely access error message
    const errorMessage = error?.message || '';

    // Handle initialization errors (like missing env vars)
    if ((error as any)?.isInitializationError) {
      if (errorMessage.includes('API access token')) {
        return 'Missing required environment variables. Please check your configuration.';
      }
      return 'There was an error initializing the application. Please refresh the page or contact support.';
    }

    // Handle API/network errors
    if ((error as any)?.isConnectionError) {
      return 'Unable to connect to the server. Please check your connection and try again.';
    }

    return 'We are sorry, there seems to be an issue with our application. Please reach out to support@sippsafely.com or try again later.'
  };

  return (
    <Dialog 
      open={!!error} 
      onClose={handleClose}
      disableEscapeKeyDown={(error as any)?.isInitializationError}
    >
      <DialogTitle>Application Error</DialogTitle>
      <DialogContent>
        <Typography>
          {getErrorMessage(error)}
        </Typography>
        {process.env.NODE_ENV === 'development' && error?.message && (
          <Typography color="error" variant="body2" sx={{ mt: 2 }}>
            {error.message}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>
          {(error as any)?.isInitializationError ? 'Reload' : 'Close'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}; 